import { APP_ROUTES } from '@app/app.routes.model';
import { RBAC_ACTIONS } from '@api/model/rbac-actions';
import { UserFeatureFlags } from '@api/model/my-api';

export interface MenuItem {
  label: string;
  link: string;
  rbacActionKey?: string;
  restrictedFeature?: keyof UserFeatureFlags;
  icon: string;
}

const appRoutes = APP_ROUTES;

const commonMenuItems: MenuItem[] = [
  {
    label: 'menuitem.myProfile',
    link: appRoutes.profile,
    icon: 'icon-user',
  },
  {
    label: 'menuitem.requests',
    link: appRoutes.requests.root,
    icon: 'icon-menu-request',
  },
  {
    label: 'menuitem.offerings',
    link: appRoutes.offerings.root,
    icon: 'icon-menu-offers',
  },
  {
    label: 'menuitem.matches',
    link: appRoutes.matches.root,
    icon: 'icon-menu-match',
  },
  {
    label: 'menuitem.deals',
    link: appRoutes.deals.root,
    icon: 'icon-menu-deal',
  },
];
export const hdMenuItems: MenuItem[] = [
  {
    label: 'menuitem.dashboard',
    link: appRoutes.hdZone + '/' + appRoutes.dashboard,
    icon: 'icon-menu-dashboard',
  },
  ...commonMenuItems,
  {
    label: 'menuitem.organizations',
    link: appRoutes.hdZone + '/' + appRoutes.organizations.root,
    rbacActionKey: RBAC_ACTIONS.organizationList,
    icon: 'icon-menu-organizations',
  },
  {
    label: 'menuitem.settings',
    link: appRoutes.hdZone + '/' + appRoutes.platformAdministration.root,
    restrictedFeature: 'platformAdministration',
    icon: 'icon-menu-settings',
  },
  {
    label: 'menuitem.hdusers',
    link:
      appRoutes.hdZone +
      '/' +
      appRoutes.platformAdministration.hdUserManagement,
    restrictedFeature: 'platformAdministration',
    icon: 'icon-user',
  },
  {
    label: 'menuitem.orgusers',
    link:
      appRoutes.hdZone +
      '/' +
      appRoutes.platformAdministration.orgUserManagement,
    restrictedFeature: 'platformAdministration',
    icon: 'icon-user',
  },
];

export const orgMenuItems: MenuItem[] = [
  ...commonMenuItems,
  {
    label: 'menuitem.myOrganization',
    link: appRoutes.organizations.myOrganization,
    icon: 'icon-menu-organizations',
  },
];
